(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gad-article"] && !Shopify.designMode) return;
  try {
    
  class GadArticle extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const reduce = window.Gadsden && Gadsden.reduceMotion();
      if (!reduce) {
        this.querySelectorAll('[data-gad-ar-ticks]').forEach((vs) => {
          vs.classList.add('is-armed');
          const io = new IntersectionObserver((entries) => {
            if (!entries[0].isIntersecting) return;
            io.disconnect();
            vs.classList.add('is-in');
          }, { threshold: 0.4 });
          io.observe(vs);
        });
      }
      const bar = this.querySelector('[data-gad-ar-bar]');
      const head = this.querySelector('.gad-ar__head');
      if (bar && head) {
        const body = this.querySelector('.gad-ar__body');
        const sync = () => {
          this.raf = 0;
          const h = head.getBoundingClientRect();
          const end = body.getBoundingClientRect();
          bar.hidden = !(h.bottom < 0 && end.bottom > window.innerHeight * 0.6);
        };
        this.onScroll = () => this.raf || (this.raf = requestAnimationFrame(sync));
        window.addEventListener('scroll', this.onScroll, { passive: true });
        sync();
      }
    }

    disconnectedCallback() {
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this._ready = false;
    }
  }

  if (!customElements.get('gad-article')) customElements.define('gad-article', GadArticle);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-auto-steps"] && !Shopify.designMode) return;
  try {
    
  class GadAutoSteps extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.bars = [...this.querySelectorAll('.gad-as__bar')];
      this.track = this.querySelector('.gad-as__track');
      this.cta = this.querySelector('[data-gad-as-cta]');
      this.ms = parseInt(this.dataset.ms, 10) || 4000;
      this.auto = !(window.Gadsden && Gadsden.reduceMotion());
      if (!this.auto) this.classList.add('is-static');
      this.bars.forEach((b) => b.addEventListener('click', () => this.go(Number(b.dataset.i))));
      this.bars.forEach((b) => b.querySelector('span').addEventListener('animationend', () => this.go(this.i + 1, true)));
      const vp = this.querySelector('.gad-as__viewport');
      vp.addEventListener('pointerdown', (e) => {
        this.x0 = e.clientX;
        this.classList.add('is-paused');
      });
      vp.addEventListener('pointerup', (e) => {
        this.classList.remove('is-paused');
        const dx = e.clientX - (this.x0 ?? e.clientX);
        if (Math.abs(dx) > 40) this.go(this.i + (dx < 0 ? 1 : -1));
      });
      vp.addEventListener('pointercancel', () => this.classList.remove('is-paused'));
      this.addEventListener('shopify:block:select', (e) => {
        const i = [...this.querySelectorAll('.gad-as__card')].indexOf(e.target);
        if (i >= 0) this.go(i);
        this.classList.add('is-paused');
      });
      this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      this.i = 0;
      const io = new IntersectionObserver((entries) => this.classList.toggle('is-paused', !entries[0].isIntersecting));
      io.observe(this);
      this.go(0);
    }

    go(i, fromTimer) {
      const n = this.bars.length;
      if (fromTimer && this.i === n - 1) return;
      if (i >= n || i < 0) i = 0;
      this.i = i;
      this.track.style.transform = `translateX(${document.dir === 'rtl' ? '' : '-'}${i * 100}%)`;
      this.bars.forEach((b, k) => {
        b.classList.remove('is-active');
        b.classList.toggle('is-done', k < i);
        b.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      void this.bars[i].offsetWidth;
      this.bars[i].classList.add('is-active');
      if (this.cta) this.cta.hidden = i !== n - 1;
    }
  }

  if (!customElements.get('gad-auto-steps')) customElements.define('gad-auto-steps', GadAutoSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-before-after"] && !Shopify.designMode) return;
  try {
    
  class GadBeforeAfter extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.range = this.querySelector('.gad-ba__range');
      this.range.addEventListener('input', () => this.set(parseFloat(this.range.value)));
      this.addEventListener('pointerdown', (e) => this.down(e));
      this.elastic = this.classList.contains('gad-ba--elastic') && !(window.Gadsden && Gadsden.reduceMotion());
      if (this.elastic) this.setupElastic();
    }

    set(pct, yFrac) {
      const v = Math.max(0, Math.min(100, pct));
      this.style.setProperty('--pos', `${v}%`);
      this.range.value = Math.round(v);
      if (this.elastic) {
        this.target = v;
        if (yFrac != null) this.hy = Math.max(0.1, Math.min(0.9, yFrac));
        this.style.setProperty('--hy', `${this.hy * 100}%`);
        this.kick();
      }
    }

    fromEvent(e) {
      const r = this.getBoundingClientRect();
      this.lastY = (e.clientY - r.top) / r.height;
      return ((e.clientX - r.left) / r.width) * 100;
    }

    /* Línea elástica: los extremos de la línea siguen a la manija con un resorte. */
    setupElastic() {
      this.classList.add('is-elastic');
      this.after = this.querySelector('.gad-ba__img--after');
      this.curve = this.querySelector('.gad-ba__curve path');
      const start = parseFloat(this.dataset.start) || 50;
      this.target = start;
      this.hy = 0.5;
      this.ends = { top: start, bot: start, vt: 0, vb: 0 };
      this.draw();
      new ResizeObserver(() => this.draw()).observe(this);
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(() => this.set(start + 14), 150);
        setTimeout(() => this.set(start), 650);
      }, { threshold: 0.5 });
      io.observe(this);
    }

    kick() {
      if (this.raf) return;
      let last = performance.now();
      const step = (now) => {
        const dt = Math.min(0.032, (now - last) / 1000);
        last = now;
        const e = this.ends;
        const k = 620;
        const c = 44;
        e.vt += (k * (this.target - e.top) - c * e.vt) * dt;
        e.vb += (k * (this.target - e.bot) - c * e.vb) * dt;
        e.top += e.vt * dt;
        e.bot += e.vb * dt;
        this.draw();
        const still = Math.abs(this.target - e.top) < 0.05 && Math.abs(this.target - e.bot) < 0.05 && Math.abs(e.vt) < 0.5 && Math.abs(e.vb) < 0.5;
        if (still) {
          e.top = e.bot = this.target;
          e.vt = e.vb = 0;
          this.draw();
          this.raf = 0;
          return;
        }
        this.raf = requestAnimationFrame(step);
      };
      this.raf = requestAnimationFrame(step);
    }

    draw() {
      const W = this.clientWidth;
      const H = this.clientHeight;
      if (!W || !H) return;
      const xt = (this.ends.top / 100) * W;
      const xb = (this.ends.bot / 100) * W;
      const xh = (this.target / 100) * W;
      const yh = this.hy * H;
      const t = this.hy;
      const cx = (xh - (1 - t) * (1 - t) * xt - t * t * xb) / (2 * t * (1 - t));
      const cy = (yh - t * t * H) / (2 * t * (1 - t));
      const d = `M ${xt.toFixed(1)} 0 Q ${cx.toFixed(1)} ${cy.toFixed(1)} ${xb.toFixed(1)} ${H}`;
      this.curve.setAttribute('d', d);
      this.after.style.clipPath = `path('${d} L ${W} ${H} L ${W} 0 Z')`;
    }

    down(e) {
      if (e.button > 0) return;
      const start = { x: e.clientX, y: e.clientY, decided: e.pointerType === 'mouse' };
      if (start.decided) this.set(this.fromEvent(e), this.lastY);
      const move = (ev) => {
        if (!start.decided) {
          const dx = Math.abs(ev.clientX - start.x);
          const dy = Math.abs(ev.clientY - start.y);
          if (dx < 6 && dy < 6) return;
          start.decided = true;
          if (dy > dx) return end();
        }
        ev.preventDefault();
        this.set(this.fromEvent(ev), this.lastY);
      };
      const end = () => {
        window.removeEventListener('pointermove', move);
        window.removeEventListener('pointerup', end);
        window.removeEventListener('pointercancel', end);
      };
      window.addEventListener('pointermove', move, { passive: false });
      window.addEventListener('pointerup', end);
      window.addEventListener('pointercancel', end);
    }
  }

  if (!customElements.get('gad-before-after')) customElements.define('gad-before-after', GadBeforeAfter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-chapters"] && !Shopify.designMode) return;
  try {
    
  class GadChapters extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.caps = [...this.querySelectorAll('.gad-ch__cap')];
      this.tabs = [...this.querySelectorAll('.gad-ch__tab')];
      this.seconds = parseFloat(this.dataset.seconds) || 5;
      this.auto = !(window.Gadsden && Gadsden.reduceMotion());
      this.i = 0;
      this.visible = false;
      this.tabs.forEach((t) => t.addEventListener('click', () => this.go(Number(t.dataset.i), true)));
      this.caps.forEach((cap, i) => {
        const v = cap.querySelector('video');
        if (!v) return;
        v.addEventListener('timeupdate', () => i === this.i && v.duration && this.fill(v.currentTime / v.duration));
        v.addEventListener('ended', () => i === this.i && this.next());
      });
      new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.visible ? this.play() : this.stop();
      }, { threshold: 0.4 }).observe(this);
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.caps.indexOf(e.target);
        if (i >= 0) this.go(i, true);
      });
    }

    fill(r) {
      this.tabs.forEach((t, k) => (t.querySelector('.gad-ch__fill').style.transform = `scaleX(${k < this.i ? 1 : k === this.i ? r : 0})`));
    }

    video() {
      return this.caps[this.i].querySelector('video');
    }

    play() {
      const v = this.video();
      cancelAnimationFrame(this.raf);
      if (v) {
        if (this.auto) v.play().catch(() => {});
        return;
      }
      if (!this.auto) return;
      const start = performance.now() - (this.elapsed || 0);
      const tick = (now) => {
        this.elapsed = now - start;
        const r = Math.min(1, this.elapsed / (this.seconds * 1000));
        this.fill(r);
        if (r >= 1) return this.next();
        this.raf = requestAnimationFrame(tick);
      };
      this.raf = requestAnimationFrame(tick);
    }

    stop() {
      cancelAnimationFrame(this.raf);
      const v = this.video();
      if (v) v.pause();
    }

    next() {
      this.go((this.i + 1) % this.caps.length);
    }

    go(i, user) {
      this.stop();
      const old = this.video();
      if (old) old.currentTime = 0;
      this.i = i;
      this.elapsed = 0;
      this.caps.forEach((c, k) => c.classList.toggle('is-active', k === i));
      this.tabs.forEach((t, k) => {
        t.classList.toggle('is-active', k === i);
        t.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      this.fill(0);
      const v = this.video();
      if (v && user && !this.auto) v.play().catch(() => {});
      if (this.visible) this.play();
    }
  }

  if (!customElements.get('gad-chapters')) customElements.define('gad-chapters', GadChapters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-closing"] && !Shopify.designMode) return;
  try {
    
  class GadClosing extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        this.classList.add('is-in');
      }, { threshold: 0.5 });
      io.observe(this.querySelector('.gad-cl__title'));
    }
  }

  if (!customElements.get('gad-closing')) customElements.define('gad-closing', GadClosing);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-coverflow"] && !Shopify.designMode) return;
  try {
    
  class GadCoverflow extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.cards = [...this.querySelectorAll('.gad-cf__card')];
      this.n = this.cards.length;
      this.pos = 0;
      this.range = parseInt(this.dataset.range, 10) || 0;
      this.flat = !!(window.Gadsden && Gadsden.reduceMotion());
      this.querySelector('.gad-cf__arrow--prev').addEventListener('click', () => this.snapTo(Math.round(this.pos) - 1));
      this.querySelector('.gad-cf__arrow--next').addEventListener('click', () => this.snapTo(Math.round(this.pos) + 1));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.snapTo(Math.round(this.pos) - 1);
        if (e.key === 'ArrowRight') this.snapTo(Math.round(this.pos) + 1);
      });
      this.addEventListener('pointerdown', (e) => this.down(e));
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.cards.indexOf(e.target);
        if (i >= 0) this.snapTo(i);
      });
      this.ro = new ResizeObserver(() => this.render());
      this.ro.observe(this);
      this.io = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
        this.syncVideos();
      });
      this.io.observe(this);
      this.render();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      if (this.io) this.io.disconnect();
      this._ready = false;
    }

    offset(i) {
      let d = i - this.pos;
      d = ((((d + this.n / 2) % this.n) + this.n) % this.n) - this.n / 2;
      return d;
    }

    render() {
      const w = this.cards[0] ? this.cards[0].offsetWidth : 260;
      this.cards.forEach((card, i) => {
        const d = this.offset(i);
        const a = Math.min(Math.abs(d), 3);
        const x = d * w * (this.flat ? 1.05 : 0.62);
        const scale = this.flat ? 1 : 1 - Math.min(a, 1) * 0.3;
        const rot = this.flat ? 0 : Math.max(-1, Math.min(1, d)) * -20;
        card.style.transform = `translateX(${x}px) rotateY(${rot}deg) scale(${scale})`;
        card.style.zIndex = String(50 - Math.round(a * 10));
        card.style.opacity = a > 2.6 ? '0' : '1';
      });
      this.syncVideos();
    }

    syncVideos() {
      const center = Math.round(this.pos);
      this.cards.forEach((card, i) => {
        const v = card.querySelector('video');
        if (!v) return;
        const near = Math.abs(this.offset(i)) <= this.range + 0.5;
        if (this.visible && near && !this.flat) {
          if (v.preload === 'none') v.preload = 'auto';
          v.play().catch(() => {});
        } else if (!v.paused) v.pause();
        if (this.flat && this.visible && ((i % this.n) + this.n) % this.n === ((center % this.n) + this.n) % this.n) v.play().catch(() => {});
      });
    }

    down(e) {
      if (e.target.closest('.gad-cf__arrow')) return;
      cancelAnimationFrame(this.anim);
      const w = this.cards[0].offsetWidth * (this.flat ? 1.05 : 0.62);
      const startX = e.clientX;
      const startPos = this.pos;
      let lastX = e.clientX;
      let lastT = performance.now();
      let v = 0;
      this.classList.add('is-dragging');
      this.setPointerCapture(e.pointerId);
      const move = (ev) => {
        const now = performance.now();
        v = (ev.clientX - lastX) / Math.max(1, now - lastT);
        lastX = ev.clientX;
        lastT = now;
        this.pos = startPos - (ev.clientX - startX) / w;
        this.render();
      };
      const up = () => {
        this.removeEventListener('pointermove', move);
        this.removeEventListener('pointerup', up);
        this.removeEventListener('pointercancel', up);
        this.classList.remove('is-dragging');
        const fling = this.flat ? 0 : Math.max(-2, Math.min(2, (-v * 120) / w));
        this.snapTo(Math.round(this.pos + fling));
      };
      this.addEventListener('pointermove', move);
      this.addEventListener('pointerup', up);
      this.addEventListener('pointercancel', up);
    }

    snapTo(target) {
      cancelAnimationFrame(this.anim);
      if (this.flat) {
        this.pos = target;
        return this.render();
      }
      const from = this.pos;
      const start = performance.now();
      const dur = 420;
      const step = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const e = 1 - Math.pow(1 - t, 3);
        this.pos = from + (target - from) * e;
        this.render();
        if (t < 1) this.anim = requestAnimationFrame(step);
      };
      this.anim = requestAnimationFrame(step);
    }
  }

  if (!customElements.get('gad-coverflow')) customElements.define('gad-coverflow', GadCoverflow);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-guarantee"] && !Shopify.designMode) return;
  try {
    
  class GadGuarantee extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && Gadsden.reduceMotion())) return;
      this._ready = true;
      const arc = this.querySelector('.gad-gr__arc');
      const num = this.querySelector('[data-gad-gr-num]');
      const days = parseInt(this.dataset.days, 10) || 0;
      const circ = parseFloat(arc.getAttribute('stroke-dasharray'));
      arc.style.strokeDashoffset = circ;
      num.textContent = '0';
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const dur = 1400;
        const tick = (now) => {
          const t = Math.min(1, (now - start) / dur);
          const e = 1 - Math.pow(1 - t, 3);
          arc.style.strokeDashoffset = circ * (1 - e);
          num.textContent = String(Math.round(days * e));
          if (t < 1) requestAnimationFrame(tick);
        };
        requestAnimationFrame(tick);
      }, { threshold: 0.4 });
      io.observe(this);
    }
  }

  if (!customElements.get('gad-guarantee')) customElements.define('gad-guarantee', GadGuarantee);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-hero-slides"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gad-hero__sound');
    if (!btn) return;
    const videos = btn.closest('.gad-hero__slide').querySelectorAll('video');
    const unmute = btn.getAttribute('aria-pressed') !== 'true';
    videos.forEach((v) => {
      v.muted = !unmute;
      if (unmute && v.offsetParent !== null && v.paused) v.play().catch(() => {});
    });
    btn.setAttribute('aria-pressed', String(unmute));
    btn.setAttribute('aria-label', unmute ? btn.dataset.labelMute : btn.dataset.labelUnmute);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-hotspots"] && !Shopify.designMode) return;
  try {
    
  class GadHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const el = e.target.closest('[data-gad-hs]');
        if (el) this.select(el.dataset.gadHs, el.classList.contains('gad-hs__point'));
      });
      this.addEventListener('shopify:block:select', (e) => {
        const li = e.target.closest('[data-gad-hs]');
        if (li) this.select(li.dataset.gadHs, false);
      });
    }

    select(n, fromPoint) {
      this.querySelectorAll('[data-gad-hs]').forEach((el) => el.classList.toggle('is-active', el.dataset.gadHs === n));
      const li = this.querySelector(`.gad-hs__item[data-gad-hs="${n}"]`);
      if (fromPoint && li && li.getBoundingClientRect().top > window.innerHeight) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  if (!customElements.get('gad-hotspots')) customElements.define('gad-hotspots', GadHotspots);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-merge"] && !Shopify.designMode) return;
  try {
    
  class GadMerge extends HTMLElement {
    connectedCallback() {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => this.merge(), { once: true });
      else this.merge();
    }

    merge() {
      if (!this.isConnected) return;
      this.moved = [];
      [this.dataset.a1, this.dataset.a2].forEach((id, i) => {
        const target = id && document.getElementById(id);
        const sec = target && target.closest('.shopify-section');
        const slot = this.querySelector(`[data-gad-merge-slot="${i + 1}"]`);
        if (!sec || sec.contains(this) || !slot) return;
        const mark = document.createComment('gad-merge');
        sec.before(mark);
        slot.appendChild(sec);
        this.moved.push([sec, mark]);
      });
      const note = this.querySelector('.gad-merge__note');
      if (note) note.hidden = this.moved.length === 2;
    }

    disconnectedCallback() {
      (this.moved || []).forEach(([sec, mark]) => {
        if (mark.parentNode) mark.replaceWith(sec);
      });
      this.moved = [];
    }
  }

  if (!customElements.get('gad-merge')) customElements.define('gad-merge', GadMerge);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-parallax-hero"] && !Shopify.designMode) return;
  try {
    
  class GadParallax extends HTMLElement {
    connectedCallback() {
      if (this._ready || !window.matchMedia('(hover: hover)').matches) return;
      this._ready = true;
      this.layers = Array.from(this.querySelectorAll('.gad-px__layer'));
      this.k = parseFloat(this.dataset.intensity) || 20;
      this.addEventListener('pointermove', (e) => {
        if (window.Gadsden && Gadsden.reduceMotion()) return;
        const r = this.getBoundingClientRect();
        const nx = ((e.clientX - r.left) / r.width - 0.5) * 2;
        const ny = ((e.clientY - r.top) / r.height - 0.5) * 2;
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.move(nx, ny));
      });
      this.addEventListener('pointerleave', () => this.move(0, 0));
    }

    move(nx, ny) {
      this.layers.forEach((el) => {
        const d = (parseFloat(el.dataset.depth) || 0) / 10;
        el.style.transform = `translate3d(${(-nx * d * this.k).toFixed(1)}px, ${(-ny * d * this.k).toFixed(1)}px, 0)`;
      });
    }
  }

  if (!customElements.get('gad-parallax')) customElements.define('gad-parallax', GadParallax);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-quiz"] && !Shopify.designMode) return;
  try {
    
  class GadQuiz extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.screens = [...this.querySelectorAll('[data-gad-qz]')];
      this.qs = this.screens.filter((s) => s.dataset.gadQz === 'q');
      this.answers = [];
      this.addEventListener('click', (e) => {
        const t = e.target.closest('[data-gad-qz-start], [data-gad-qz-opt], [data-gad-qz-back], [data-gad-qz-restart]');
        if (!t) return;
        if (t.hasAttribute('data-gad-qz-start')) this.show(this.qs[0]);
        else if (t.hasAttribute('data-gad-qz-back')) this.back();
        else if (t.hasAttribute('data-gad-qz-restart')) this.restart();
        else this.pick(t);
      });
      this.addEventListener('shopify:block:select', (e) => this.show(e.target));
    }

    show(screen) {
      this.screens.forEach((s) => (s.hidden = s !== screen));
      if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start', behavior: window.Gadsden && Gadsden.reduceMotion() ? 'auto' : 'smooth' });
      const focusable = screen.querySelector('h3');
      if (focusable) {
        focusable.setAttribute('tabindex', '-1');
        focusable.focus({ preventScroll: true });
      }
    }

    pick(btn) {
      const screen = btn.closest('[data-gad-qz]');
      const i = this.qs.indexOf(screen);
      screen.querySelectorAll('[data-gad-qz-opt]').forEach((o) => o.classList.toggle('is-picked', o === btn));
      this.answers[i] = btn.dataset.tag || '';
      this.answers.length = i + 1;
      setTimeout(() => (i + 1 < this.qs.length ? this.show(this.qs[i + 1]) : this.finish()), 220);
    }

    back() {
      const cur = this.qs.findIndex((s) => !s.hidden);
      if (cur > 0) this.show(this.qs[cur - 1]);
    }

    restart() {
      this.answers = [];
      this.querySelectorAll('.is-picked').forEach((o) => o.classList.remove('is-picked'));
      this.show(this.screens[0]);
    }

    finish() {
      if (this.answers.includes('!')) return this.show(this.screens.find((s) => s.dataset.gadQz === 'cut'));
      const score = {};
      this.answers.filter((t) => t && t !== '!').forEach((t) => (score[t] = (score[t] || 0) + 1));
      const results = this.screens.filter((s) => s.dataset.gadQz === 'result');
      let best = null;
      results.forEach((r) => {
        const p = r.dataset.profile;
        if (p && (score[p] || 0) > 0 && (!best || score[p] > (score[best.dataset.profile] || 0))) best = r;
      });
      if (!best) best = results.find((r) => !r.dataset.profile) || results[0];
      if (best) this.show(best);
    }
  }

  if (!customElements.get('gad-quiz')) customElements.define('gad-quiz', GadQuiz);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-reading-progress"] && !Shopify.designMode) return;
  try {
    
  class GadReadingProgress extends HTMLElement {
    connectedCallback() {
      this.hidden = false;
      this.bar = this.querySelector('.gad-rp__bar');
      this.onScroll = () => {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = 0;
          const total = document.documentElement.scrollHeight - window.innerHeight;
          this.bar.style.transform = `scaleX(${total > 0 ? Math.min(1, window.scrollY / total) : 0})`;
        });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
    }
  }

  if (!customElements.get('gad-reading-progress')) customElements.define('gad-reading-progress', GadReadingProgress);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-results"] && !Shopify.designMode) return;
  try {
    
  class GadRing extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.target = parseFloat(this.dataset.value) || 0;
      this.num = this.querySelector('.gad-ring__num');
      if (window.Gadsden && (Gadsden.reduceMotion() || Gadsden.designMode)) return;
      this.style.setProperty('--p', 0);
      if (this.num) this.num.textContent = '0';
      this.io = new IntersectionObserver((entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        this.io.disconnect();
        this.animate();
      }, { rootMargin: '0px 0px -10% 0px' });
      this.io.observe(this);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      this._ready = false;
    }

    animate() {
      const duration = 1200;
      const start = performance.now();
      const step = (now) => {
        const t = Math.min(1, (now - start) / duration);
        const eased = 1 - Math.pow(1 - t, 3);
        const value = this.target * eased;
        this.style.setProperty('--p', value);
        if (this.num) this.num.textContent = Math.round(value);
        if (t < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('gad-ring')) customElements.define('gad-ring', GadRing);

  /* Dato libre (S10): si tiene un número, cuenta desde cero conservando lo que lo rodea. */
  class GadCount extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && (Gadsden.reduceMotion() || Gadsden.designMode))) return;
      this._ready = true;
      const text = this.textContent.trim();
      const m = text.match(/\d[\d.,]*/);
      if (!m) return;
      const raw = m[0];
      const sep = /[.,]\d{3}(\D|$)/.test(raw) ? raw.match(/[.,]/)[0] : '';
      const target = parseInt(raw.replace(/[.,]/g, ''), 10);
      if (!target) return;
      const fmt = (n) => (sep ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, sep) : String(n));
      const paint = (n) => (this.textContent = text.replace(raw, fmt(n)));
      paint(0);
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        const start = performance.now();
        const step = (now) => {
          const t = Math.min(1, (now - start) / 1200);
          paint(Math.round(target * (1 - Math.pow(1 - t, 3))));
          if (t < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
      io.observe(this);
    }
  }

  if (!customElements.get('gad-count')) customElements.define('gad-count', GadCount);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-reveal-cards"] && !Shopify.designMode) return;
  try {
    
  class GadRevealCards extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.toggles = [...this.querySelectorAll('.gad-rc__toggle')];
      this.dialog = this.querySelector('.gad-rc__dialog');
      this.toggles.forEach((t) =>
        t.addEventListener('click', () => {
          const open = t.getAttribute('aria-expanded') === 'true';
          this.toggles.forEach((o) => o.setAttribute('aria-expanded', 'false'));
          if (!open) t.setAttribute('aria-expanded', 'true');
        })
      );
      this.querySelectorAll('.gad-rc__open').forEach((btn) =>
        btn.addEventListener('click', () => {
          this.dialog.querySelector('h3').textContent = btn.dataset.title;
          this.dialog.querySelector('.gad-rc__dtext').replaceChildren(btn.nextElementSibling.content.cloneNode(true));
          this.dialog.showModal();
          document.documentElement.classList.add('gad-modal-open');
        })
      );
      this.dialog.querySelector('.gad-rc__close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (e) => {
        if (e.target === this.dialog) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => document.documentElement.classList.remove('gad-modal-open'));
      this.addEventListener('shopify:block:select', (e) => {
        const t = e.target.querySelector('.gad-rc__toggle');
        if (t && t.getAttribute('aria-expanded') !== 'true') t.click();
      });
    }
  }

  if (!customElements.get('gad-reveal-cards')) customElements.define('gad-reveal-cards', GadRevealCards);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-reviews-wall"] && !Shopify.designMode) return;
  try {
    
  class GadReviewsWall extends HTMLElement {
    connectedCallback() {
      const btn = this.querySelector('[data-gad-rw-btn]');
      if (!btn) return;
      const batch = parseInt(this.dataset.batch, 10) || 8;
      btn.addEventListener('click', () => {
        const hidden = [...this.querySelectorAll('[data-gad-rw-more][hidden]')];
        hidden.slice(0, batch).forEach((el) => (el.hidden = false));
        if (hidden.length <= batch) btn.parentElement.remove();
      });
    }
  }

  if (!customElements.get('gad-reviews-wall')) customElements.define('gad-reviews-wall', GadReviewsWall);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-rotating-hero"] && !Shopify.designMode) return;
  try {
    
  class GadRotatingHero extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && Gadsden.reduceMotion())) return;
      this._ready = true;
      const words = [...this.querySelectorAll('.gad-rh__word')];
      const ms = (parseFloat(this.dataset.speed) || 2.5) * 1000;
      if (words.length > 1) {
        let i = 0;
        this.timer = setInterval(() => {
          if (document.hidden) return;
          const prev = words[i];
          i = (i + 1) % words.length;
          words.forEach((w) => w.classList.remove('is-out'));
          prev.classList.remove('is-active');
          prev.classList.add('is-out');
          words[i].classList.add('is-active');
        }, ms);
      }
      const bg = this.querySelector('.gad-rh__bg');
      const k = parseFloat(this.dataset.parallax) || 0;
      if (bg && k) {
        this.onScroll = () => {
          const r = this.getBoundingClientRect();
          if (r.bottom < 0 || r.top > window.innerHeight) return;
          bg.style.transform = `translate3d(0, ${(-r.top * k) / 100}px, 0)`;
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this._ready = false;
    }
  }

  if (!customElements.get('gad-rotating-hero')) customElements.define('gad-rotating-hero', GadRotatingHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-shoppable"] && !Shopify.designMode) return;
  try {
    
  class GadShoppable extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.onDoc = (e) => {
        this.querySelectorAll('details[open]').forEach((d) => {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      };
      this.onKey = (e) => {
        if (e.key === 'Escape') this.querySelectorAll('details[open]').forEach((d) => d.removeAttribute('open'));
      };
      document.addEventListener('click', this.onDoc);
      document.addEventListener('keydown', this.onKey);
      this.addEventListener('shopify:block:select', (e) => e.target.setAttribute('open', ''));
      this.addEventListener('shopify:block:deselect', (e) => e.target.removeAttribute('open'));
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.onDoc);
      document.removeEventListener('keydown', this.onKey);
      this._ready = false;
    }
  }

  if (!customElements.get('gad-shoppable')) customElements.define('gad-shoppable', GadShoppable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-stamps"] && !Shopify.designMode) return;
  try {
    
  class GadStamps extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && Gadsden.reduceMotion()) || (window.Shopify && Shopify.designMode)) return;
      this._ready = true;
      const stamps = [...this.querySelectorAll('.gad-st2__stamp')];
      if (!stamps.length) return;
      const delay = parseInt(this.dataset.delay, 10) || 350;
      this.classList.add('is-armed');
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        stamps.forEach((el, i) => setTimeout(() => el.classList.add('is-in'), 150 + i * delay));
      }, { threshold: 0.3 });
      io.observe(this.querySelector('.gad-st2__row'));
    }
  }

  if (!customElements.get('gad-stamps')) customElements.define('gad-stamps', GadStamps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-tabs"] && !Shopify.designMode) return;
  try {
    
  class GadTabs extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.nav = this.querySelector('.gad-tabs__nav');
      this.buttons = Array.from(this.querySelectorAll('.gad-tabs__btn'));
      this.panels = Array.from(this.querySelectorAll('.gad-tabs__panel'));
      this.indicator = this.querySelector('.gad-tabs__indicator');
      this.buttons.forEach((btn, i) => {
        btn.addEventListener('click', () => this.select(i, false));
        btn.addEventListener('keydown', (e) => this.onKey(e, i));
      });
      this.addEventListener('shopify:block:select', (e) => {
        const i = this.panels.findIndex((p) => p.contains(e.target));
        if (i >= 0) this.select(i, false);
      });
      this.ro = new ResizeObserver(() => this.moveIndicator());
      if (this.nav) this.ro.observe(this.nav);
      this.moveIndicator();
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      this._ready = false;
    }

    select(i, focus) {
      this.buttons.forEach((btn, j) => {
        const on = i === j;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-selected', String(on));
        btn.tabIndex = on ? 0 : -1;
        if (on && focus) btn.focus();
      });
      this.panels.forEach((panel, j) => {
        panel.hidden = i !== j;
        if (i !== j) panel.querySelectorAll('video').forEach((v) => v.pause());
      });
      this.moveIndicator();
    }

    onKey(e, i) {
      const keys = ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp', 'Home', 'End'];
      if (!keys.includes(e.key)) return;
      e.preventDefault();
      const n = this.buttons.length;
      let next = i;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = (i + 1) % n;
      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = (i - 1 + n) % n;
      if (e.key === 'Home') next = 0;
      if (e.key === 'End') next = n - 1;
      this.select(next, true);
    }

    moveIndicator() {
      if (!this.indicator) return;
      const active = this.buttons.find((b) => b.classList.contains('is-active'));
      if (!active) return;
      this.indicator.style.width = `${active.offsetWidth}px`;
      this.indicator.style.height = `${active.offsetHeight}px`;
      this.indicator.style.transform = `translate(${active.offsetLeft}px, ${active.offsetTop}px)`;
    }
  }

  if (!customElements.get('gad-tabs')) customElements.define('gad-tabs', GadTabs);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-ticker"] && !Shopify.designMode) return;
  try {
    
  class GadTicker extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.track = this.querySelector('.gad-ticker__track');
      this.group = this.querySelector('.gad-ticker__group');
      if (!this.track || !this.group) return;
      this.base = Array.from(this.group.children);
      if (!this.base.length) return;
      this.speed = parseFloat(this.dataset.speed) || 2;
      this.addEventListener('touchstart', () => this.classList.contains('gad-ticker--pause') && this.classList.add('is-paused'), { passive: true });
      this.addEventListener('touchend', () => this.classList.remove('is-paused'));
      this.addEventListener('shopify:block:select', () => this.classList.add('is-paused'));
      this.addEventListener('shopify:block:deselect', () => this.classList.remove('is-paused'));
      this.ro = new ResizeObserver(() => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.build());
      });
      this.ro.observe(this);
      this.build();
      this.track.addEventListener(
        'load',
        () => {
          this._built = false;
          this.build();
        },
        true
      );
    }

    disconnectedCallback() {
      if (this.ro) this.ro.disconnect();
      this._ready = false;
    }

    build() {
      const vertical = this.classList.contains('gad-ticker--vertical');
      const width = vertical ? this.clientHeight : this.clientWidth;
      if (!width) return;
      if (this._lastWidth === width && this._built) return;
      this._lastWidth = width;
      this.track.querySelectorAll('[data-ticker-clone]').forEach((el) => el.remove());
      this.base.forEach((el) => this.group.appendChild(el));
      if (window.Gadsden && Gadsden.reduceMotion()) {
        this.classList.remove('is-running');
        this._built = true;
        return;
      }
      const measure = () => (vertical ? this.group.scrollHeight : this.group.scrollWidth);
      let unitWidth = measure();
      let guard = 0;
      while (unitWidth > 0 && unitWidth < width && guard < 30) {
        this.base.forEach((el) => this.group.appendChild(this.cloneItem(el)));
        unitWidth = measure();
        guard++;
      }
      const copy = this.group.cloneNode(true);
      copy.setAttribute('data-ticker-clone', '');
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
      this.track.appendChild(copy);
      const pxPerSecond = this.speed * 30;
      this.style.setProperty('--dur', `${Math.max(4, unitWidth / pxPerSecond)}s`);
      this.classList.add('is-running');
      this._built = true;
    }

    cloneItem(el) {
      const clone = el.cloneNode(true);
      clone.setAttribute('data-ticker-clone', '');
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('data-shopify-editor-block');
      clone.inert = true;
      return clone;
    }
  }

  if (!customElements.get('gad-ticker')) customElements.define('gad-ticker', GadTicker);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gad-timed-steps"] && !Shopify.designMode) return;
  try {
    
  class GadTimedSteps extends HTMLElement {
    connectedCallback() {
      if (this._ready || (window.Gadsden && Gadsden.reduceMotion())) return;
      this._ready = true;
      this.total = parseFloat(this.dataset.total) || 0;
      this.digits = this.querySelector('[data-gad-ts-digits]');
      this.stamps = [...this.querySelectorAll('[data-gad-ts-stamp]')];
      this.classList.add('is-armed');
      if (this.digits) this.digits.textContent = '0,0';
      const io = new IntersectionObserver((entries) => {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        this.run();
      }, { threshold: 0.35 });
      io.observe(this);
    }

    run() {
      this.stamps.forEach((el, i) => setTimeout(() => el.classList.add('is-in'), 300 + i * 450));
      if (!this.digits || !this.total) return;
      const start = performance.now();
      const tick = (now) => {
        const t = Math.min(this.total, (now - start) / 1000);
        this.digits.textContent = t.toFixed(1).replace('.', ',');
        if (t < this.total) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }
  }

  if (!customElements.get('gad-timed-steps')) customElements.define('gad-timed-steps', GadTimedSteps);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbx-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lbx-hotspots"] && !Shopify.designMode) return;
  try {
    
  class GadHotspots extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        const el = e.target.closest('[data-gad-hs]');
        if (el) this.select(el.dataset.gadHs, el.classList.contains('gad-hs__point'));
      });
      this.addEventListener('shopify:block:select', (e) => {
        const li = e.target.closest('[data-gad-hs]');
        if (li) this.select(li.dataset.gadHs, false);
      });
    }

    select(n, fromPoint) {
      this.querySelectorAll('[data-gad-hs]').forEach((el) => el.classList.toggle('is-active', el.dataset.gadHs === n));
      const li = this.querySelector(`.gad-hs__item[data-gad-hs="${n}"]`);
      if (fromPoint && li && li.getBoundingClientRect().top > window.innerHeight) li.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  if (!customElements.get('gad-hotspots')) customElements.define('gad-hotspots', GadHotspots);

  class LbxHotspots extends HTMLElement {
    connectedCallback() {
      this.veil = this.querySelector('.lbx-hs__veil');
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('.lbx-hs__point');
        if (btn) {
          const spot = btn.closest('.lbx-hs__spot');
          spot.classList.contains('is-open') ? this.close() : this.open(spot);
          return;
        }
        if (e.target === this.veil) this.close();
      });
      this.onDocClick = (e) => {
        if (!this.contains(e.target)) this.close();
      };
      this.onKey = (e) => {
        if (e.key === 'Escape') this.close();
      };
      this.onScroll = () => this.place();
      this.addEventListener('shopify:block:select', (e) => {
        const spot = e.target.closest('.lbx-hs__spot');
        if (spot) this.open(spot);
      });
      this.addEventListener('shopify:block:deselect', () => this.close());
    }

    open(spot) {
      this.close();
      this.current = spot;
      spot.classList.add('is-open');
      spot.querySelector('.lbx-hs__point').setAttribute('aria-expanded', 'true');
      const pop = spot.querySelector('.lbx-hs__pop');
      pop.hidden = false;
      pop.classList.remove('lbx-hs__pop--left');
      if (window.matchMedia('(min-width: 750px)').matches && pop.getBoundingClientRect().right > window.innerWidth - 8) {
        pop.classList.add('lbx-hs__pop--left');
      }
      if (window.matchMedia('(max-width: 749px)').matches) this.veil.hidden = false;
      this.place();
      document.addEventListener('click', this.onDocClick);
      document.addEventListener('keydown', this.onKey);
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    place() {
      if (!this.current) return;
      const r = this.current.querySelector('.lbx-hs__point').getBoundingClientRect();
      this.current.querySelector('.lbx-hs__pop').style.setProperty('--lbx-hs-top', `${r.top + r.height / 2}px`);
      // Como en el live, el velo arranca en el borde de arriba de la sección y deja sin oscurecer lo de arriba.
      const top = this.closest('.shopify-section').getBoundingClientRect().top;
      this.veil.style.top = `${Math.max(0, top)}px`;
    }

    close() {
      if (!this.current) return;
      this.current.classList.remove('is-open');
      this.current.querySelector('.lbx-hs__point').setAttribute('aria-expanded', 'false');
      this.current.querySelector('.lbx-hs__pop').hidden = true;
      this.veil.hidden = true;
      this.current = null;
      document.removeEventListener('click', this.onDocClick);
      document.removeEventListener('keydown', this.onKey);
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  if (!customElements.get('lbx-hotspots')) customElements.define('lbx-hotspots', LbxHotspots);

  } catch(e) { console.error(e); }
})();
})();
